export enum ARTICLE {
  MANAGE = '/articles/manage/:id',
  ADD = '/articles/add/:id',
  EDIT = '/articles/edit/:id',
  ARTICLE = '/articles/:id/articles',
}
